import "../../styles/src/index.scss";

export interface WithCSSImportsProps {
    children: React.ReactNode
}

export const WithCSSImports = (props: WithCSSImportsProps) => {
    const { children } = props

    return children
}
